export default __webpack_public_path__ + "static/media/email.20900557.svg";